<template>
	<component v-bind:is="currentComponent" v-bind="componentProps" v-on="componentListeners"></component>
</template>

<script>
import AlertTypeService from './AlertTypes/AlertTypeService';

export default {
	name: 'AlertCard',
	props: {
		alert: { type: Object },
		hideIcon: { type: Boolean },
	},
	components: {},
	computed: {
		alertConf() {
			return AlertTypeService.getAlertActionTypeConfiguration(this.alert.action_type);
		},
		componentProps() {
			return { alert: this.alert, hideIcon: this.hideIcon };
		},
		componentListeners() {
			return {};
		},
		currentComponent() {
			return this.alertConf.component;
		},
	},
	methods: {},
};
</script>

<style scoped lang="scss">
.v-tooltip__content {
	opacity: 1 !important;
	padding: 6px 5px !important;
	color: var(--bg-color) !important;
	background-color: var(--tooltop-black-background) !important;
}
.v-tooltip__content:after {
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	width: 0 !important;
	height: 0 !important;
	content: '' !important;
	bottom: -5px !important;
	position: absolute !important;
	border-left: 5px solid transparent !important;
	border-right: 5px solid transparent !important;
	border-top: 5px solid var(--tooltop-black-background) !important;
}

.alert-card {
	width: 1024px;
	margin-top: 30px;
	padding-right: 38px;

	.archive-alert-container {
		display: none;
	}
	&:hover {
		.archive-alert-container {
			display: flex;
		}
	}

	.archive-alert {
		width: 30px;
		height: 30px;
		margin-left: 8px;
	}

	.card-container {
		width: 100%;
		height: 70px;
		padding: 0px 30px;
		justify-content: space-between;
		background-color: var(--bg-color) !important;
		border: 1px solid #dfe4ef !important;
		box-shadow: var(--card-shadow) !important;
		&:hover {
			background-color: var(--app-dialog-bg) !important;
		}

		.alert-title {
			font-size: 14px;
			text-align: left !important;
			color: #292829 !important;
		}

		.action-button {
			height: 30px;
			width: 140px;
			color: #5b8af7;
			border-radius: 8px;
			border: 1px solid #5b8af7;
			background-color: var(--bg-color) !important;

			.action-button-text {
				font-size: 14px;
				text-align: center;
				color: #5b8af7 !important;
			}
		}
		.no-border {
			border: none;
		}
		.alert-switch {
			font-size: 12px;
			padding-top: 16px;
		}
	}
}
</style>
